export default __webpack_public_path__ + "static/media/bodybackground.74821cde.jpg";